<template>
    <div class="newsDetail">

        <div v-if="article && article.image" class="newsDetail__image">
            <div class="container">
                <div class="col-12 col-bleed">
                    <!-- TODO @Marco: Show this only if source is available -->
                    <div v-if="article && article.image && article.image.credits" class="newsDetail__image__source">
                        Foto: {{ article.image.credits }}
                    </div>
                    <img :src="baseUrl + article.scaled_image_url" alt="">
                </div>
            </div>
            <img :src="baseUrl + article.scaled_image_url" alt="">
        </div>

        <div class="container">
            <div class="grid">
                <div class="col-md-8 offset-md-2 col-bleed-y" v-if="article">
                    <div class="newsDetail__content">
                        <div v-if="matchData" class="newsDetail__result" @click="openMatch">
                            <img :src="teamLogoUrl(matchData.fmpTeamHomeId, 40)" alt="">
                            <template v-if="matchData.resultCode.startsWith('scheduled') || matchData.resultCode == 'postponed'">- : -</template>
                            <template v-else>{{ matchData.goalsHome }}:{{ matchData.goalsAway }}</template>
                            <img :src="teamLogoUrl(matchData.fmpTeamAwayId, 40)"  alt="">
                        </div>
                        <h1>{{ article.title }}</h1>
                        <p class="newsDetail__intro">
                            {{ article.intro }}
                        </p>
                        <div class="newsDetail__author">
                            <router-link :to="'/team/' + authorTeamSlug() + '/' + competitionId" v-if="article.authorship" class="newsDetail__author__avatar">
                                <img :src="teamLogoUrl(article.authorship.fmpForeignId, 80)" alt=""/>
                            </router-link>
                            <div class="newsDetail__author__text">
                                <div v-if="article.authorship" class="newsDetail__author__text__user">
                                    von <router-link :to="'/team/' + authorTeamSlug() + '/' + competitionId">{{ article.authorship.name }}</router-link>
                                </div>
                                <div class="newsDetail__author__text__meta">
                                    {{ formatDate(articleDate) }}・{{ formatTime(articleDate) }} Uhr
                                </div>
                            </div>
                            <div v-if="showShareButton" class="newsDetail__author__share" @click="shareArticle">
                                <img src="@/assets/ic_16_share.svg" alt="Teilen">
                                Teilen
                            </div>
                        </div>
                        <div v-html="article.body"></div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="latestArticles" class="newsDetail__more">
            <h3>Weitere interessante Artikel:</h3>
            <div class="container">
                <div class="grid">
                    <div class="col-12 col-bleed-y">
                        <div class="newsDetail__more__content">
                            <NewsCard v-for="article in latestArticles" v-bind:key="article.id" :article="article"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import NewsCard from '@/components/NewsCard.vue'
import axios from 'axios';
import moment from 'moment';
import { slugify } from '@/hbf-helper';
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";

export default {
    setup() {
        const siteData = reactive({
            title: 'Handball Bundesliga Frauen',
            description: '',
            image: '',
        });

        useHead({
            // Can be static or computed
            title: computed(() => siteData.title),
            meta: [
                {
                    name: `description`,
                    content: computed(() => siteData.description),
                },
                {
                    name: 'og:type',
                    content: "article"
                },
                {
                    name: 'og:image',
                    content: computed(() => siteData.image),
                },
                {
                    name: 'og:title',
                    content: computed(() => siteData.title),
                }
            ],
        });

        return {
            siteData
        }
    },
    name: 'NewsViewDetail',
    components: {
        NewsCard
    },
    data() {
        return {
            article: null,
            latestArticles: null,
            errorLoadingArticle: false,
            matchData: null,
            leagueData: null,
            homeTeam: null,
            awayTeam: null,
            showShareButton: false,
            competitionId: null,
            competitions: [],
        }
    },
    methods: {
        init(articleId) {
            this.showShareButton = navigator.share;
            if (this.isNumeric(articleId)) {
                this.loadArticle(articleId);
            }
            else {
                let apiUrl = this.$store.getters.getApiUrl;
                axios
                    .get(apiUrl + 'pages/?slug=' + articleId)
                    .then(response => {
                        let searchResult = response.data;
                        if (searchResult.items && searchResult.items.length > 0) {
                            articleId = searchResult.items[0].id;
                            this.loadArticle(articleId);
                        }
                    });
            }
        },
        openMatch() {
            if (!this.matchData) { return; }
            this.$router.push("/match/" + this.matchData.fmpMatchId + "/" + this.competitionId);
        },
        teamSlug(team) {
            return team.fmpTeamId + "--" + slugify(team.teamName);
        },
        authorTeamSlug() {
            if (this.article.authorship) {
                return this.article.authorship.fmpForeignId + "--" + slugify(this.article.authorship.name);
            }
            return "";
        },
        teamHomeName() {
            if (this.homeTeam) {
                return this.homeTeam.teamName;
            }
            return "Heimmannschaft";
        },
        teamAwayName() {
            if (this.awayTeam) {
                return this.awayTeam.teamName;
            }
            return "Gastmannschaft";
        },
        shareArticle() {
            const data = {
                url: document.location,
                title: this.article.title
            };
            try {
                navigator.share(data).then(() => console.log("sharing successful"));
            }
            catch(err) {
                console.log(err);
            }
        },
        formatDate(d) {
            let newDate = moment(d)
            return newDate.format("DD.MM.YYYY");
        },
        formatTime(d) {
            let newDate = moment(d)
            return newDate.format("HH:mm");
        },
        loadArticle(articleId) {
            let apiUrl = this.$store.getters.getApiUrl;

            axios
            .get(apiUrl + 'pages/' + articleId + "/")
            .then(response => {
                this.article = response.data;

                this.siteData.title = this.article.title + " | Handball Bundesliga Frauen";
                this.siteData.description = this.article.meta.search_description || this.article.intro;
                this.siteData.image = this.baseUrl + this.article.scaled_image_url;
                
                if (this.article.match_id) {
                    this.$store.dispatch("fetchData",  {filename: "matches/match_" + this.article.match_id + ".json"}).then( (res) => {
                        this.matchData = res;

                        this.$store.dispatch("fetchData",  {filename: "leagues/league_" + this.matchData.fmpSeasonId + ".json"}).then( (res) => {
                            this.leagueData = res;
                            this.homeTeam = this.leagueData.teams.find(t => t.fmpTeamId == this.matchData.fmpTeamHomeId);
                            this.awayTeam = this.leagueData.teams.find(t => t.fmpTeamId == this.matchData.fmpTeamAwayId);

                            // find the correct internal competition id in the list of all FMP season ids for a given league
                            // this is necessary so that links to teams still work in older articles (with past season match data)
                            this.$store.dispatch("fetchCompetitions").then( () => {
                                this.competitions = this.$store.getters.getCompetitions;
                                this.leagueData.seasons.some(s => {
                                    let competition = this.competitions.find(c => c.fmpSeasonId == s.fmpSeasonId);
                                    if (competition) {
                                        this.competitionId = competition.id;
                                        return true;
                                    }
                                });
                            });
                        });
                    });
                }
            })
            .catch(error => {
                console.log(error);
                // set article object to only contain id so the removeLike button can work
                this.errorLoadingArticle = true;
            });
            this.$store.dispatch('fetchArticles').then(() => {
                this.latestArticles = this.$store.getters.getArticles.slice(0, 3);
            });
        },
        isNumeric(str) {
            if (typeof str != "string") return false // we only process strings!  
            return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
                    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
        },
        teamLogoUrl(teamId, width) {
            return this.baseUrl + "/fmp/teamlogo/" + width + "/" + teamId;
        }
    },
    mounted() {
        this.init(this.$route.params.id);
    },
    beforeRouteUpdate (to, from, next) {
        this.init(to.params.id);
        next();
    },
    computed: {
        articleDate() {
            if (!this.article) { return null; }
            if (this.article.go_live_at) { return this.article.go_live_at; }
            return this.article.meta.first_published_at;
        },
        baseUrl() {
            return this.$store.getters.getBaseUrl;
        }
    }
}
</script>

<style lang="scss">
    .newsDetail {
        &__image {
            display: flex;
            position: relative;
            overflow: hidden;

            img {
                display: flex;
                position: relative;
                z-index: 2;
                width: calc(100% + 48px);
                margin: 0 -24px;
                max-height: 200px;
                object-fit: cover;

                @media (min-width: 414px) {
                    max-height: 220px;
                }

                @media (min-width: 480px) {
                    max-height: 240px;
                }

                @media (min-width: $breakpoint-xs) {
                    max-height: 300px;
                }

                @media (min-width: $breakpoint-sm) {
                    width: 100%;
                    margin: 0;
                    max-height: 520px;
                }

                @media (min-width: $breakpoint-lg) {
                    max-height: 560px;
                }
            }

            > img {
                display: none;
                position: absolute;
                z-index: 1;
                width: calc(100% + 128px);
                height: calc(100% + 128px);
                left: -64px;
                top: -64px;
                filter: blur(16px);

                @media (min-width: $breakpoint-xs) {
                    display: block;
                }
            }

            &__source {
                position: absolute;
                bottom: 4px;
                right: -20px;
                z-index: 3;
                background: rgba(0,0,0, .56);
                border-radius: 4px;
                padding: 3px 5px;
                color: rgba($colorWhite, .8);
                font-size: 9px;

                @media (min-width: $breakpoint-sm) {
                    bottom: 8px;
                    right: 8px;
                    font-size: 11px;
                }
            }
        }

        &__content {
            display: flex;
            flex-direction: column;

            a {
                color: $colorPrimary;
                font-weight: 600;
            }
        }

        &__result {
            position: relative;
            z-index: 3;
            display: inline-flex;
            align-items: center;
            padding: 8px 12px;
            background: $colorWhite;
            box-shadow: 0 0 0 1px rgba($colorBlack, .06), 0 8px 24px 0 rgba($colorBlack, .04), 0 2px 8px 0 rgba($colorBlack, .02);
            border-radius: 28px;
            font-size: 14px;
            line-height: 14px;
            font-weight: 700;
            color: $colorBlack;
            margin: -16px auto -8px 0;
            cursor: pointer;
            transition: all .2s ease-in-out;

            @media (min-width: $breakpoint-sm) {
                padding: 16px 20px;
                font-size: 20px;
                line-height: 20px;
                font-weight: 800;
                margin: -28px auto -28px 0;
            }

            &:hover {
                box-shadow: 0 0 0 1px rgba($colorBlack, .06), 0 12px 24px 0 rgba($colorBlack, .06), 0 6px 8px 0 rgba($colorBlack, .02);
            }

            img {
                width: 16p;
                height: 16px;
                object-fit: contain;

                @media (min-width: $breakpoint-sm) {
                    width: 24px;
                    height: 24px;
                }

                &:first-of-type {
                    margin-right: 8px;

                    @media (min-width: $breakpoint-sm) {
                        margin-right: 12px;
                    }
                }

                &:last-of-type {
                    margin-left: 8px;

                    @media (min-width: $breakpoint-sm) {
                        margin-left: 12px;
                    }
                }
            }
        }

        h1 {
            margin-top: 25px;
            margin-bottom: 8px;

            @media (max-width: $breakpoint-sm - 1px) {
                font-size: 20px;
                line-height: 28px;
                letter-spacing: -0.48px;
            }

            @media (min-width: $breakpoint-sm) {
                margin-top: 62px;
                margin-bottom: 14px;
            }
        }

        h2 {
            margin: 18px 0 2px;

            @media (min-width: $breakpoint-sm) {
                margin: 33px 0 7px;
                font-size: 28px;
                line-height: 36px;
                letter-spacing: -0.58px;
            }
        }

        &__intro {
            font-weight: 700;
        }

        &__author {
            display: flex;
            align-items: center;
            padding: 16px 24px;
            width: calc(100% + 48px);
            margin: 16px -24px;
            box-shadow: 0 -1px 0 0 rgba($colorBlack, .08), 0 1px 0 0 rgba($colorBlack, .08);

            @media (min-width: $breakpoint-sm) {
                width: 100%;
                margin: 24px 0;
                padding: 16px 0;
            }

            &__avatar {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 32px;
                height: 32px;
                background: $colorWhite;
                box-shadow: 0 0 0 1.5px rgba($colorBlack, .04);
                border-radius: 50%;
                margin-right: 8px;

                @media (min-width: $breakpoint-sm) {
                    width: 40px;
                    height: 40px;
                    box-shadow: 0 0 0 2px rgba($colorBlack, .04);
                    margin-right: 16px;
                }

                img {
                    width: 24px;
                    height: 24px;
                    object-fit: contain;

                    @media (min-width: $breakpoint-sm) {
                        width: 32px;
                        height: 32px;
                    }
                }
            }

            &__text {
                display: flex;
                flex-direction: column;
                font-size: 11px;
                line-height: 15px;
                font-weight: 600;

                @media (min-width: $breakpoint-sm) {
                    font-size: 14px;
                    line-height: 18px;
                }

                &__user, a {
                    color: $colorBlack;
                }

                &__meta {
                    color: rgba($colorBlack, .48);
                }
            }

            &__share {
                display: flex;
                align-items: center;
                font-size: 14px;
                line-height: 14px;
                font-weight: 700;
                letter-spacing: -0.33px;
                margin-left: auto;
                background: $colorWhite;
                padding: 8px 16px 8px 12px;
                box-shadow: 0 0 0 1.5px rgba($colorBlack, .04), 0 8px 24px 0 rgba($colorBlack, .04), 0 2px 8px 0 rgba($colorBlack, .02);
                border-radius: 16px;
                cursor: pointer;
                transition: all .2s ease-in-out;

                &:hover {
                    box-shadow: 0 0 0 2px rgba($colorBlack, .04), 0 12px 32px 0 rgba($colorBlack, .08), 0 2px 8px 0 rgba($colorBlack, .02);
                }

                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                    transform: translateY(-1px);
                }
            }
        }

        figure {
            display: flex;
            flex-direction: column;
            padding: 0;
            width: calc(100% + 48px);
            margin: 24px -24px;

            @media (min-width: $breakpoint-sm) {
                width: calc(100% + 64px);
                margin: 40px -32px;
            }
            
            img {
                width: 100%;
                height: 220px;
                object-fit: cover;

                @media (min-width: $breakpoint-sm) {
                    height: 460px;
                    border-radius: 8px;
                }
            }

            figcaption {
                padding: 8px 24px;
                box-shadow: inset 0 -1px 0 0 rgba($colorBlack, .08);

                @media (min-width: $breakpoint-sm) {
                    padding: 18px 0 2px;
                    box-shadow: none;
                }

                .caption {
                    font-size: 11px;
                    line-height: 16px;
                    font-weight: 600;

                    @media (min-width: $breakpoint-sm) {
                        font-weight: 700;
                        text-align: center;
                    }

                    &--text {
                        color: $colorBlack;

                        @media (min-width: $breakpoint-sm) {
                            font-size: 20px;
                            line-height: 26px;
                        }
                    }

                    &--credits {
                        color: rgba($colorBlack, .48);

                        @media (min-width: $breakpoint-sm) {
                            font-size: 14px;
                            line-height: 20px;
                        }
                    }
                }
            }
        }

        &__more {
            margin: 27px 0;

            @media (min-width: $breakpoint-sm) {
                margin: 68px 0;
            }

            > h3 {
                text-align: center;
                color: rgba($colorBlack, .48);

                @media (min-width: $breakpoint-sm) {
                    font-size: 20px;
                }
            }

            &__content {
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                margin-top: 6px;

                @media (min-width: $breakpoint-sm) {
                    margin-top: 16px;
                    gap: 16px;
                }

                .news-card {
                    width: 100%;

                    @media (min-width: $breakpoint-sm) {
                        width: calc((100% - 24px) / 2);
                    }

                    @media (min-width: $breakpoint-md) {
                        width: calc((100% - 48px) / 3);
                    }
                }
            }
        }
    }
</style>